import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAccountApi } from '../../hooks/use-settings-api';
import { QK_TWO_FACTOR_RECOVERY_CODES } from './use-recovery-codes';

export function useRegenerateRecoveryCodes() {
  const { accountApi } = useAccountApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => accountApi.regenerateRecoveryCodes(),
    // Remove, don't invalidate - the old codes are dead the moment this succeeds, so they must
    // not stay on screen as though they were current while the refetch is in flight.
    onSuccess: () => queryClient.removeQueries({ queryKey: QK_TWO_FACTOR_RECOVERY_CODES }),
  });
}
